import { EmptyState } from "./KpiCard";

export function DataTable({ columns, rows, rowKey = "id", onRowClick, empty, testid }) {
  if (!rows || rows.length === 0)
    return <EmptyState title={empty?.title || "No records yet"} hint={empty?.hint} />;
  return (
    <div className="bg-white border border-stone-200 rounded-xl overflow-hidden" data-testid={testid}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b-2 border-stone-300 bg-stoney/60">
              {columns.map((c) => (
                <th key={c.key}
                  className={`px-4 py-3 text-xs uppercase tracking-wider font-medium text-[#5C5C54] ${c.align === "right" ? "text-right" : "text-left"}`}>
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row[rowKey]}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                data-testid={`row-${row[rowKey]}`}
                className={`ledger-row border-b border-stone-100 transition-colors duration-200 ${onRowClick ? "cursor-pointer" : ""}`}>
                {columns.map((c) => (
                  <td key={c.key}
                    className={`px-4 py-3 ${c.align === "right" ? "text-right font-mono tabular" : "text-left"} ${c.className || "text-[#1A1A1A]"}`}
                    style={{ minHeight: 44 }}>
                    {c.render ? c.render(row) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
